import { GridColDef } from "@mui/x-data-grid";
import { useTranslation } from "react-i18next";
import MainApiService from "../../../../services/mainApi.service";
import { Table } from "@4uhub/lib4uhub";
import { ICommunicationPermissions } from "../../../../models/communication-permissions";

const BANK_ROUTE = process.env.REACT_APP_MAIN + "/api/v1/MarComOptInOut";
const bankService = new MainApiService<ICommunicationPermissions>(BANK_ROUTE);

const translationPath = "page.4uMarCom.communicationPermissions.";

const CommunicationPermissionsPage = () => {
  const { t } = useTranslation();

  const columns: GridColDef<ICommunicationPermissions>[] = [
    {
      field: "name",
      headerName: t(translationPath + "name") || "Name",
    },
    {
      field: "document",
      headerName: t(translationPath + "document") || "Document",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
    {
      field: "birthOfDate",
      headerName: t(translationPath + "birthOfDate") || "Birth Date",
      renderCell: (params) => {
        if (!params.value) return "-";
        return params.value.name;
      },
    },
  ];

  return (
    <Table<ICommunicationPermissions>
      showDefaultMacroFilters={false}
      service={bankService}
      columns={columns}
      title={t(translationPath + "title")}
      searchInput
      showButton={false}
      defaultActions={false}
      showDeleteButton={false}
      showDelete={false}
      searchInputPlaceHolder={
        t(translationPath + "search") || "Search for a list classification"
      }
      addButtonLabel={t(translationPath + "add") || "Add List Classification"}
      confirmOptions={{
        title: t(translationPath + "confirm.title"),
        description: t(translationPath + "confirm.description"),
        confirmationButtonProps: {
          variant: "contained",
        },
      }}
    />
  );
};

export default CommunicationPermissionsPage;
